import { render, staticRenderFns } from "./service-editor.vue?vue&type=template&id=4a8ac287&"
import script from "./service-editor.vue?vue&type=script&lang=js&"
export * from "./service-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports